import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=6a1c2b8c&scoped=true&"
import script from "./addressManage.vue?vue&type=script&lang=js&"
export * from "./addressManage.vue?vue&type=script&lang=js&"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=6a1c2b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c2b8c",
  null
  
)

export default component.exports